import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Copy, Box, Flex, ErrorsWrapper, themeColor } from '@elparking/components'
import StyledPlaceSelect from './StyledPlaceSelect'
import { Airport, Station, Locality } from './Icons'
import {
    RENTAL_CAR_POI_TYPE_AIRPORT,
    RENTAL_CAR_POI_TYPE_STATION,
    RENTAL_CAR_POI_TYPE_CITY,
    RENTAL_CAR_POI_TYPE_LOCALITY,
} from 'commons/js/constants'

const placeIcon = {
    [RENTAL_CAR_POI_TYPE_AIRPORT]: <Airport color='gray' />,
    [RENTAL_CAR_POI_TYPE_STATION]: <Station color='gray' />,
    [RENTAL_CAR_POI_TYPE_CITY]: <Locality color='gray' />,
    [RENTAL_CAR_POI_TYPE_LOCALITY]: <Locality color='gray' />,
}

const PlacesSelectOption = ({ label, name, type }) => {
    return (
        <Flex dataTest={'rental-car-search-form-places-option-' + label} alignItems='center'>
            <Box pr='0.5em'>
                {placeIcon[type]}
            </Box>
            <Box>
                <Copy padding='0' fontSize='medium' fontColor='gray' fontWeight='book'>{label}</Copy>
                <Copy padding='0' fontSize='small' fontColor='gray60' fontWeight='regular'>{name}</Copy>
            </Box>
        </Flex>
    )
}

PlacesSelectOption.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
}

const getBorderColor = ({ state, error }) => {
    if (state.isFocused && !error) {
        return themeColor('focusColor')
    }
    if (error) {
        return themeColor('error')
    }
    return themeColor('lightGray')
}

const getCustomStyles = ({ error }) => {
    return {
        control: (provided, state) => ({
            ...provided,
            border: `1 px solid ${getBorderColor({ state, error })}`,
            boxShadow: 'none',
        }),
    }
}

function PlaceSelectWrapper ({
    value,
    initialSearchValue,
    autocompleteService,
    placeholder,
    label,
    onChange,
    error,
    errorMessage,
    hideClearButton,
    required,
    ariaRoleDescription,
}) {
    const customStyles = useMemo(() => {
        return error ? getCustomStyles({ error }) : {}
        }, [error])
    return (
        <Box>
            <Copy>{label}</Copy>
            <StyledPlaceSelect
              dataTest='rental-car-search-form-places'
              value={value}
              initialSearchValue={initialSearchValue}
              autocompleteService={autocompleteService}
              placeholder={placeholder}
              label={label}
              hideClearButton={hideClearButton}
              onChange={onChange}
              optionRenderer={PlacesSelectOption}
              error={error}
              customStyles={customStyles}
              customTheme={(theme) => {
                    return {
                        ...theme,
                        colors: {
                            ...theme.colors,
                            primary: '#2377BC',
                        },
                    }
              }}
              required={required}
              ariaRoleDescription={ariaRoleDescription}
            />
            {error && <ErrorsWrapper><Copy padding='0 0.5em' mt='4px' fontColor='error' fontWeight='regular' >{errorMessage}</Copy></ErrorsWrapper>}
        </Box>
    )
}

PlaceSelectWrapper.defaultProps = {
    hideClearButton: false,
}

PlaceSelectWrapper.propTypes = {
    hideClearButton: PropTypes.bool,
    value: PropTypes.any,
    initialSearchValue: PropTypes.any,
    autocompleteService: PropTypes.func,
    placeholder: PropTypes.any,
    label: PropTypes.any,
    onChange: PropTypes.func,
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
    required: PropTypes.bool,
    ariaRoleDescription: PropTypes.string,
}

export default PlaceSelectWrapper
